import React from 'react';
import {CATEGORICAL_SEQUENCE} from './chartTheme';

type Stage = {label: string; value: number};

type Props = {
    stages: Stage[];
};

/**
 * A stage-by-stage pipeline (service requests -> applications ->
 * negotiations -> contracts -> active collaborations). Built as horizontal
 * proportional bars rather than recharts' Funnel/trapezoid shape - more
 * legible at a glance and doesn't need per-shape tuning to avoid looking
 * skewed with real, uneven drop-off data.
 */
const FunnelStages: React.FC<Props> = ({stages}) => {
    const max = Math.max(1, ...stages.map((s) => s.value));

    return (
        <div className="d-flex flex-column gap-3">
            {stages.map((stage, i) => {
                const pct = Math.round((stage.value / max) * 100);
                const dropOff = i > 0 && stages[i - 1].value > 0
                    ? Math.round(((stages[i - 1].value - stage.value) / stages[i - 1].value) * 100)
                    : null;
                return (
                    <div key={stage.label}>
                        <div className="d-flex justify-content-between align-items-baseline mb-1">
                            <span className="fw-semibold small">{stage.label}</span>
                            <span className="small text-muted">
                                {stage.value}
                                {dropOff !== null && dropOff > 0 && (
                                    <span className="ms-2 text-danger">−{dropOff}%</span>
                                )}
                            </span>
                        </div>
                        <div style={{
                            height: 10, borderRadius: 6, background: '#f3f3f9', overflow: 'hidden',
                        }}>
                            <div style={{
                                width: `${pct}%`,
                                height: '100%',
                                borderRadius: 6,
                                background: CATEGORICAL_SEQUENCE[i % CATEGORICAL_SEQUENCE.length],
                                transition: 'width .3s ease',
                            }}/>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FunnelStages;
